import React from 'react';
import FuseAuthorization from '@fuse/core/FuseAuthorization';
import FuseLayout from '@fuse/core/FuseLayout';
import { ErrorBoundary } from 'app/main/pages/components/ErrorBoundary';
import { Outlet } from 'react-router-dom';

const GlobalLayout = () => {
  return (
    // Return error page
    <ErrorBoundary>
      {/* Check if access granted */}
      <FuseAuthorization>
        {/* Return global layout */}
        <FuseLayout>
          {/* routes */}
          <Outlet />
        </FuseLayout>
      </FuseAuthorization>
    </ErrorBoundary>
  );
};

export default GlobalLayout;
